import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import qs from "qs"

import Image from "./Image"
import EmailCapture from "./EmailCapture"

import styles from "./emailCapture.module.scss"
import overlayStyles from "./overlay.module.scss"
import settingStyles from "./settings.module.scss"

import { toTitleCase, cookie, trackEvent } from "../helpers"


const EmailCaptureModal = ({ location }) => {

  const data = useStaticQuery(graphql`
    query EmailCaptureQuery {
      contentfulEmailCapture(componentName: {eq: "Redesign 2020 Email Capture Popup"}) {
        image {
          desktopImage {
            fluid(maxWidth: 760, quality: 90) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
          altText
          url
        }
        listId
        heading {
          heading
        }
        text {
          json
        }
        textAlignment
        cta {
          text
        }
        disclaimerRichText {
          json
        }
        confirmationHeading {
          heading
        }
        confirmationText
        confirmationCta {
          url
          text
        }
        formName
        source
        captureSource
        captureLocation
        captureTrafficSource
        offerDiscountCode
      }
    }
  `)

  const {
    image,
    listId,
    heading,
    text,
    textAlignment,
    cta,
    disclaimerRichText,
    confirmationHeading,
    confirmationText,
    confirmationCta,
    formName,
    source,
    captureSource,
    captureLocation,
    captureTrafficSource,
    offerDiscountCode,
  } = data.contentfulEmailCapture

  const textAlign = toTitleCase(textAlignment || "center")

  const [showEmailCaptureModal, setShowEmailCaptureModal] = useState(false)
  
  useEffect(() => {
    const hasCookie = cookie.get("newsletter-hide") === "1"

    const parsedQuery = qs.parse(location.search, { ignoreQueryPrefix: true })
    const fromEmail = !!parsedQuery._ke || parsedQuery.utm_medium === "email"

    const urlExclusions = [
      "pages/refer",
      "pages/refer-get",
      "pages/refer-self",
      "pages/welcome",
      "pages/alc",
      "pages/frame",
      "pages/mobile-closet-sweeps",
      "_ke=test",
      "pages/equal-pay",
      "pages/equal-pay-day",
    ]
    const urlExclusionsJoined = urlExclusions.join("|").replace(/\//g, "\\/")
    const urlExcluded = location.pathname.search(new RegExp("("+urlExclusionsJoined+")", "gi")) >= 0

    if (!hasCookie && fromEmail) {
      cookie.set("newsletter-hide", 1, 365)
    }
    else if (!hasCookie && !urlExcluded) {
      cookie.set("newsletter-hide", 1, 14)
      setShowEmailCaptureModal(true)
      trackEvent("Email Capture", "Show", "Default")
    }
  }, [location.search, location.pathname])

  const closeModal = e => {
    setShowEmailCaptureModal(false)
  }
  
  const handleCloseButton = () => {
    closeModal()
    trackEvent("Email Capture", "Close", "X")
  }

  const handleOverlayClick = e => {
    if (e.target.className.includes("--overlay--")) {
      closeModal()
      trackEvent("Email Capture", "Close", "Background")
    }
  }

  return (
    <>
      {showEmailCaptureModal &&
        <div
          className={overlayStyles.overlay}
          role="presentation"
          onClick={handleOverlayClick}
        >
          <div className={`${styles.container} ${settingStyles[`textAlign${textAlign}`]}`}>
            <button
              className={overlayStyles.closeBtn}
              onClick={handleCloseButton}
              title="Close"
            >Close</button>
            <Image
              image={image}
              altText={image.altText}
              className={styles.image}
            />
            <EmailCapture
              heading={heading}
              text={text}
              textAlignment={textAlignment}
              submitText={cta.text}
              disclaimerText={disclaimerRichText}
              confirmationHeading={confirmationHeading}
              confirmationText={confirmationText}
              confirmationCta={confirmationCta}
              listId={listId}
              source={source}
              formName={formName}
              captureSource={captureSource}
              captureTrafficSource={captureTrafficSource}
              captureLocation={captureLocation}
              offerDiscountCode={offerDiscountCode}
              location={location}
              closeModal={closeModal}
            />
          </div>
        </div>
      }
    </>
  )
}

export default EmailCaptureModal
